import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { EmailLoginService } from 'src/Services/emaillogin.service';
import { FilterModel } from 'src/Models/filterModel';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-rmd-email-varification',
  templateUrl: './rmd-email-varification.component.html',
  styleUrls: ['./rmd-email-varification.component.css']
})
export class RmdEmailVarificationComponent implements OnInit {
  quaryValues: string = '';
  filterModel = new FilterModel();
  blockedDocument: boolean = false;

  constructor(private readonly activedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly emailLoginService: EmailLoginService,
    private sessionStorageService: SessionStorageService) {

  }

  ngOnInit() {
    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {

          this.quaryValues = params['id'];
          this.filterModel.emailKey = params['id'];
          this.isValidRMDEmailKey();
        }
        else {
          this.router.navigate(['login/' + this.quaryValues]);
        }
      }
      else {
        this.router.navigate(['login/' + this.quaryValues]);
      }
    });
  }

  isValidRMDEmailKey() {
    this.blockedDocument = true;
    this.emailLoginService.isValidRMDEmailKey(this.filterModel).subscribe(
      data => {
        this.blockedDocument = false;
        sessionStorage.setItem('EmailRMDId', data.userId);

        const userName = this.sessionStorageService.getUserName();

        if (data.status === 'Success' && userName !== null && userName !== undefined && userName.trim() !== '') {
          this.router.navigate(['/rmd/Updates/' + this.quaryValues]);
        }
        else if (data.status == 'Success')
          this.router.navigate(['login/' + this.quaryValues]);
        else
          this.router.navigate(['login']);
      },
      error => {
        this.blockedDocument = false;
        console.log(error);
        this.router.navigate(['login']);
      }
    );
  }
}